import { Feature, LineString, MultiPolygon, Polygon, Position } from "geojson";

import { booleanIntersects } from "fond/turf";

/**
 * Return the start and end coordinates of a LineString feature.
 *
 * Will raise an error if the LineString is empty.
 *
 * @param feature The LineString feature
 */
export function getLineStringEndpoints(feature: Feature<LineString>): [Position, Position] {
  const coords = feature.geometry.coordinates;
  return [coords[0], coords[coords.length - 1]];
}

/**
 * Return the last vertex of a (Multi)LineString feature, or undefined if the feature has
 * another geometry type or no vertices.
 *
 * For a MultiLineString this is the last vertex of its last line.
 */
export function getEndVertex(feature: Feature): Position | undefined {
  const { geometry } = feature;
  if (!geometry) {
    return undefined;
  }
  if (geometry.type === "LineString") {
    return geometry.coordinates.at(-1);
  }
  if (geometry.type === "MultiLineString") {
    return geometry.coordinates.at(-1)?.at(-1);
  }
  return undefined;
}

/**
 * Return the features whose geometry intersects the given geometry.
 *
 * Features without a geometry are excluded.
 */
export function filterFeaturesByGeometry(features: Feature[], geometry: Polygon | MultiPolygon): Feature[] {
  return features.filter((feature) => feature.geometry !== null && booleanIntersects(feature, geometry));
}
